var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex w-full items-center justify-between p-2"},[_c('z-button',{attrs:{"id":"mobile-menu-toggle","icon":"menu","button-type":"ghost","size":"small","color":"vanilla-100"},on:{"click":_vm.triggerExpand}}),_vm._v(" "),_c('user-menu',{attrs:{"is-collapsed":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }